import { createContext } from 'react'

export type CurrentActiveTabContextType = {
  currentActiveTab: number
  setCurrentActiveTab: (activeTab: number) => void
}

export const CurrentActiveTabContext = createContext<CurrentActiveTabContextType | undefined>(undefined)
